export default __webpack_public_path__ + "static/media/example-1.6c8ca206.png";